import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import "../../../css/search-reviewer.css";

import Searchbar from "../searchbar/Searchbar";
import SearchReviewers from "../../search/SearchReviewersToAdd";

export default function FormDialog(props) {
	const [open, setOpen] = React.useState(false);

	function handleClickOpen() {
		setOpen(true);
	}

	function handleClose() {
		setOpen(false);
	}

	return (
		<div>
			{/* Hide add reviewer button for managers */}
			{props.role === 'manager' ? <React.Fragment></React.Fragment> 
				: <Button variant="outlined" color="primary" onClick={handleClickOpen}>
					Add Reviewer
				</Button>
			}
			<Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
				<DialogTitle id="form-dialog-title">Search for a reviwer</DialogTitle>
				<DialogContent>
					<DialogContentText>
						{/* <p class="dummy-text">
							Lorem Ipsum is simply dummy text of the printing and typesetting
							industry. Lorem Ipsum has been the industry's standard dummy text ever
							since the 1500s, when an unknown printer.
						</p> */}
					</DialogContentText>
					<Searchbar
						placeholder={"Search reviewers"}
						component={SearchReviewers}
						searchEndpoint={"search/reviewers"}
						// basePath={this.props.location.pathname + "/edit"}
						// {...this.props}
						userType="admin"
						reviewId={props.reviewId}
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary">
						Close
					</Button>
					{/* <Button onClick={handleClose} color="primary">
						Add
					</Button> */}
				</DialogActions>
			</Dialog>
		</div>
	);
}



// WEBPACK FOOTER //
// ./src/components/utils/dialogs/search-reviewer-dialog.js